import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./theme/helper.scss";
import "./theme/global.scss";
import "bootstrap/dist/css/bootstrap.css";
import * as axios from "./service/axios/interceptor";
import "react-bootstrap-typeahead/css/Typeahead.css";
import * as Sentry from "@sentry/react";
import { getLocalStorageItemHandler } from "./service/local-storage";
import { IGNORE_ERROR, LOCALSTORAGE_KEYS } from "./utils/enum";
const { USER_DATA } = LOCALSTORAGE_KEYS;

let email = getLocalStorageItemHandler(USER_DATA)?.email ? getLocalStorageItemHandler(USER_DATA)?.email : null;

if (process.env.NODE_ENV.toLowerCase() === "production") {
  handleConsoles();
  includeSentry();
}
function includeSentry() {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    integrations: [new Sentry.BrowserTracing({}), new Sentry.Replay()],
    release: process.env.REACT_APP_BRANCH + "_" + process.env.REACT_APP_COMMIT,
    initialScope: (scope) => {
      scope.setTags({ userDetails: email });
      return scope;
    },
    ignoreErrors: IGNORE_ERROR,
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
function handleConsoles() {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
